module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort@3x-af60c02ca362b3e63bfd3abe8b666509.webp";